import React, { useState, useEffect } from "react";
import Modal from "./modal";

const FeatureModal = ({
  modalwCompany,
  setModalwCompany,
  handlePrintW,
  formaPgmt,
  setFormaPgmt,
  featureNames,
  onFeaturesChange,
}: {
  modalwCompany: boolean;
  setModalwCompany: (open: boolean) => void;
  handlePrintW: () => void;
  formaPgmt: string;
  setFormaPgmt: (val: string) => void;
  featureNames: string[];
  onFeaturesChange: (selected: string[]) => void; // <- nova prop
}) => {
  const [featureStates, setFeatureStates] = useState<Record<string, boolean>>(
    Object.fromEntries(featureNames.map((name) => [name, false]))
  );

  useEffect(() => {
    const selected = Object.entries(featureStates)
      .filter(([_, isSelected]) => isSelected)
      .map(([name]) => name);
    onFeaturesChange(selected); // <- envia para o componente pai
  }, [featureStates]);

  const toggleFeature = (name: string) => {
    setFeatureStates((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  return (
    <Modal
      isOpen={modalwCompany}
      onClose={() => setModalwCompany(false)}
      onSave={handlePrintW}
      title="Forma de Pagamento: "
      content={
        <div className="flex flex-col gap-4 max-h-[600px] overflow-y-auto">
          <div>
            <p>Digite abaixo a forma de pagamento que será utilizada pelo cliente.</p>
            <label
              htmlFor="default-input"
              className="block mb-2 mt-4 text-sm font-medium text-gray-900 dark:text-white"
            >
              Forma de pagamento:
            </label>
            <textarea
              value={formaPgmt}
              onChange={(e) => setFormaPgmt(e.target.value)}
              id="default-input"
              className="mb-5 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>

          <div
            className="grid gap-3"
            style={{
              display: "grid",
              gridAutoFlow: "column",
              gridTemplateRows: "repeat(5, auto)",
            }}
          >
            {featureNames.map((name, index) => (
              <label key={index} className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={featureStates[name]}
                  onChange={() => toggleFeature(name)}
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500"
                />
                <span className="text-sm text-gray-900 dark:text-gray-300">{name}</span>
              </label>
            ))}
          </div>
        </div>
      }
    />
  );
};

export default FeatureModal;
